
    import './styles.scoped.css';
    export default {
  "item-element": "awsui_item-element_93a1u_15zov_93",
  "disabled": "awsui_disabled_93a1u_15zov_105",
  "last": "awsui_last_93a1u_15zov_112",
  "highlighted": "awsui_highlighted_93a1u_15zov_115",
  "variant-icon": "awsui_variant-icon_93a1u_15zov_119",
  "variant-inline-icon": "awsui_variant-inline-icon_93a1u_15zov_119",
  "variant-normal": "awsui_variant-normal_93a1u_15zov_119",
  "variant-primary": "awsui_variant-primary_93a1u_15zov_119",
  "is-focused": "awsui_is-focused_93a1u_15zov_132",
  "variant-navigation": "awsui_variant-navigation_93a1u_15zov_136",
  "first": "awsui_first_93a1u_15zov_139",
  "has-category-header": "awsui_has-category-header_93a1u_15zov_139",
  "menu-item": "awsui_menu-item_93a1u_15zov_152",
  "icon": "awsui_icon_93a1u_15zov_170",
  "external-icon": "awsui_external-icon_93a1u_15zov_175"
};
  